import React, { Component } from "react";
import { createRoot } from "react-dom/client";
import Collection from "../components/Collection/Collection";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import ThemeProviderWrapper from "../hoc/ThemeProviderWrapper";
import ContentGrid from "../components/Grid/GridContent";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import "../styles/global.css";

const { asset } = ConfigurationHelper.getGlobalConfiguration().channelVideosData;

class Media extends Component {
    state = {
        productsCheckDone: false,
        products: [],
    };
    componentDidMount() {
        this.setProductsResponse(asset.matched);
    }
    setProductsResponse = (products) => {
        let newState = {};
        if (products && !products.length) {
            newState = {
                products: [],
            };
        } else {
            for (let index = 0; index < products.length; index++) {
                let element = products[index].entity
                    ? {
                          ...products[index].entity,
                          ...products[index].entity.data,
                      }
                    : products[index];
                element.entityIdParent = asset.id;
            }
            newState = {
                products: products.map((productItem) => {
                    return !!productItem.entity
                        ? { ...productItem.entity, ...productItem.entity.data }
                        : productItem;
                }),
            };
        }
        this.setState({ ...newState, productsCheckDone: true });
    };
    render() {
        const { products, productsCheckDone } = this.state;
        const breadcrumbs = [
            {
                name: asset.title,
                url: "#",
                active: true,
            },
        ];
        return (
            <ThemeProviderWrapper>
                <div data-testid="mediapage">
                    <Breadcrumbs breadcrumbsList={breadcrumbs} />
                    <Collection products={products} />
                    {this.state.productsCheckDone && (
                        <ContentGrid
                            isMediaPage={true}
                            productsFilter={asset.matched?.map((product) => product.id) || []}
                        />
                    )}
                </div>
            </ThemeProviderWrapper>
        );
    }
}

const targetEl = document.getElementById("app-container");

if (targetEl) {
    const root = createRoot(targetEl);
    root.render(<Media />);
}
